import axios from "axios";

const instance = axios.create({
  baseURL: "https://hideyed.avfreex24.com",
});

export default instance;
